
import React,{useEffect} from "react";
import "./teamAssignAccess.scss";
import Button from "components/Button/index";
import CreateTeamRoles from "./CreateTeamRoles/index";

function TeamAssignAccess({
  updateOperations,
  roleData,
  handleSubmit,
  handleCancel
}) {
  const isButtonDisabled =roleData.operations.length === 0;
   // const isButtonDisabled = roleData.operations.length === 0;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !isButtonDisabled) {
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isButtonDisabled, handleSubmit]);


  return (
    <div className="TeamAssignAccess">
      <div className="TeamAssignAccessWrapper">
        <CreateTeamRoles
          updateOperations={updateOperations}
          initialOperations={roleData.operations}
        />
      </div>
      <div className="TeamAssignAccessButtons">
        <Button
          type="violet"
          title="Create"
          width="100%"
          disabled={isButtonDisabled}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}

export default TeamAssignAccess;